/* TerraLife — menu mobile (snippets/horizontal-menu.liquid).
   1. Construction différée : le contenu du menu (onglets, listes, guides, raccourcis)
      attend dans <template data-tl-mobile-nav> et n'est inséré qu'une fois la page affichée,
      quand le téléphone est libre (ou au clic sur le bouton menu, si c'est avant). Les éléments
      du thème (open-children-toggle…) et la recherche des guides (tl-blog-search) sont des
      éléments personnalisés : ils s'activent seuls à l'insertion.
   2. Onglets « Menu », « Raccourcis », « Guides » : gérés ici, par délégation. Le thème
      (assets/theme.js) branche ses onglets au chargement, quand ils ne sont pas encore là :
      il ne les touche donc plus. */
(() => {
  const template = document.querySelector('template[data-tl-mobile-nav]');
  if (!template) return;
  const nav = template.closest('nav');

  const build = () => {
    if (!template.isConnected) return;
    template.replaceWith(document.importNode(template.content, true));
  };
  // Built once the page is shown and the phone is idle, so it is ready before the first tap:
  // building it during the tap itself (700 elements) made phones drop that first tap (27/10/2026).
  const whenIdle = () =>
    'requestIdleCallback' in window ? requestIdleCallback(build, { timeout: 3000 }) : setTimeout(build, 1500);
  if (document.readyState === 'complete') whenIdle();
  else window.addEventListener('load', whenIdle, { once: true });
  // A tap before that: build at once, before the theme opens the drawer.
  document.addEventListener(
    'click',
    (event) => event.target.closest && event.target.closest('.nav-toggle') && build(),
    { capture: true }
  );
  // Elsewhere the page may open the drawer itself (html.nav-open): build it then too.
  new MutationObserver(() => {
    if (document.documentElement.classList.contains('nav-open')) build();
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  nav.addEventListener('click', (event) => {
    const tab = event.target.closest('.menu-mobile-title a');
    if (!tab) return;
    event.preventDefault();
    const show = tab.dataset.menu;
    nav.querySelectorAll('.menu-mobile-title a').forEach((t) => t.classList.toggle('active', t === tab));
    const list = nav.querySelector('.horizontal-list');
    const shortcuts = nav.querySelector('.categories-list-menu-mobile');
    const guides = nav.querySelector('[data-tl-guides-panel]');
    if (list) list.style.display = show === 'horizontal-list' ? 'block' : 'none';
    if (shortcuts) shortcuts.style.display = show === 'categories-list' ? 'block' : 'none';
    if (guides) guides.hidden = show !== 'tl-guides';
  });
})();
